import React from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';

function PendingConsent() {
    const { logout, user } = useAuth();
    const navigate = useNavigate();

    const handleLogout = () => {
        logout();
        navigate('/login');
    };

    return (
        <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
            <div className="sm:mx-auto sm:w-full sm:max-w-md">
                <div className="text-center">
                    <span className="text-6xl">📝</span>
                    <h2 className="mt-6 text-3xl font-extrabold text-gray-900">
                        Finalizează configurarea contului
                    </h2>
                    <p className="mt-2 text-sm text-gray-600">
                        Salut, <strong>{user?.numeComplet || user?.email}</strong>!
                    </p>
                </div>
            </div>

            <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
                <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10 border border-yellow-200">
                    <div className="rounded-md bg-yellow-50 p-4 mb-6">
                        <div className="flex">
                            <div className="flex-shrink-0">
                                <svg className="h-5 w-5 text-yellow-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                                    <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                                </svg>
                            </div>
                            <div className="ml-3">
                                <h3 className="text-sm font-medium text-yellow-800">
                                    Acceptare Termeni Necesară
                                </h3>
                                <div className="mt-2 text-sm text-yellow-700">
                                    <p>
                                        Contul tău este creat, dar trebuie să accepți termenii și condițiile (GDPR/DPA) pentru a accesa platforma.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="space-y-6">
                        <p className="text-gray-700 text-center">
                            Te rugăm să verifici emailul (inclusiv Spam) pentru linkul de activare și confirmare a termenilor.
                        </p>

                        <button
                            onClick={handleLogout}
                            className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-brand-blue hover:bg-brand-blue-hover focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand-blue"
                        >
                            Înapoi la Autentificare
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PendingConsent;
